export const setItemData = (data) => {
    return {
        type: 'SET_ITEM_DATA',
        payload: data,
    };
};

export const setSurname = (item) => {
    return {
        type: 'SET_SURNAME',
        payload: item,
    };
};

export const setName = (item) => {
    return {
        type: 'SET_NAME',
        payload: item,
    };
};

export const setPhone = (item) => {
    return {
        type: 'SET_PHONE',
        payload: item,
    };
};

export const setCity = (item, prices) => {
    return {
        type: 'SET_CITY',
        payload: item,
        prices: prices,
    };
};

export const setStreet = (item) => {
    return {
        type: 'SET_STREET',
        payload: item,
    };
};

export const setHouse = (item) => {
    return {
        type: 'SET_HOUSE',
        payload: item,
    };
};

export const setApartment = (item) => {
    return {
        type: 'SET_APARTMENT',
        payload: item,
    };
};

export const setDelivery = (item) => {
    return {
        type: 'SET_DELIVERY',
        payload: item,
    };
};

export const setStep = (item) => {
    return {
        type: 'SET_STEP',
        payload: item,
    };
};

export const sendAnotherCode = () => {
    return {
        type: 'SEND_ANOTHER_CODE',
    };
};

export const setOrderId = (item) => {
    return {
        type: 'SET_ORDER_ID',
        payload: item,
    };
};

export const setCouponAndDiscount = (coupon, price, value) => {
    return {
        type: 'SET_COUPON_AND_PRICES',
        coupon,
        price,
        value,
    };
};
